
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: {
    imageSource: String,
    cardId: String,
    cardDate: String,
    cardName: String,
    cardInfo: String,
    click: String,
    disabled: String,
    date: String,
  },
})
export default class Card extends Vue {}
